export default{
    1: 'ALL_DAMAGE',
    2: 'ALL_SUPPORTER_DAMAGE',
    3: 'TAP_DAMAGE',
    4: 'ALL_GOLD'
};